import React, { useContext } from 'react';
import { ThemeContext } from '../theme';
import ProfileTabBar from '../components/ProfileTabBar';
import ProfileCard from '../components/ProfileCard';

// Same DP assets used in the login / Select Profile screen
const EDA_URL   = 'https://res.cloudinary.com/dcnujnpbm/image/upload/q_auto/f_auto/v1776961468/eda_dp_fszpol.webp';
const KIRAZ_URL = 'https://res.cloudinary.com/dcnujnpbm/image/upload/q_auto/f_auto/v1776961469/kiraz_dp_gs0phi.webp';

const SCALE = 0.75;
const sc = (n) => Math.round(n * SCALE);

const PROFILES = [
  { id: 'eda',   variant: 'adult', src: EDA_URL,   name: 'Eda' },
  { id: 'kiraz', variant: 'kid',   src: KIRAZ_URL, name: 'Kiraz' },
  { id: 'new',   variant: 'new',   src: null,      name: "New Kid's Profile" },
];

export default function ManageProfileScreen({ onTabChange, onEditProfile }) {
  const theme = useContext(ThemeContext);
  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', backgroundColor: theme.cardBg100, overflow: 'hidden' }}>

      {/* White rounded card */}
      <div
        style={{
          flex: 1,
          margin: sc(16),
          backgroundColor: theme.cardBg,
          borderRadius: sc(30),
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <ProfileTabBar active="manage-profile" onTabChange={onTabChange} />

        {/* Profile cards — centered vertically and horizontally */}
        <div
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: sc(20),
            padding: `${sc(32)}px ${sc(40)}px`,
          }}
        >
          {PROFILES.map(p => (
            <ProfileCard
              key={p.id}
              variant={p.variant}
              src={p.src}
              name={p.name}
              scale={0.75}
              onButton={() => onEditProfile && onEditProfile(p.id)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
